import axios from 'axios';
import { Sponsor } from '@repo/types';
import API from '../endpoints';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { getAccessToken } from '../utils/getAccessToken';

const accessToken = getAccessToken();

// 30 minutes frontend cache for main sponsor query
const CACHE_TIME = 30 * 60 * 1000;

export const useMainSponsorQuery = () => {
  return useQuery({
    queryKey: ['main-sponsor'],
    queryFn: fetchMainSponsor,
    staleTime: !accessToken ? CACHE_TIME : undefined,
  });
};

const fetchMainSponsor: QueryFunction<Sponsor, [string]> = async () => {
  const { data } = await axios.get<Sponsor>(API.endpoints.mainSponsor);
  return data;
};
